import { MDBBadge, MDBBtn, MDBCard, MDBListGroup, MDBListGroupItem } from "mdb-react-ui-kit"
import { ConfirmAction } from "../../../components/editable/ConfirmAction"
import API from "../../../service/api"
import { useTranslation } from "react-i18next"

export const ErrorsTab = ({errors}) => {
    const { t } = useTranslation();

    return (
        <MDBCard className="p-3 w-100 overflow-auto" style={{minWidth: 500}}>
            {errors.length == 0 && <span>No issues!</span> }
            {errors.length > 0 &&
                <div className="d-flex flex-column">
                    <ConfirmAction
                        title={"Clear errors"}
                        confirmText={t('clear')}
                        action={async () => await API.POST(`/api/dev`, {cmd: 'clearerrors'})}
                        prompt={"Are you sure you want to clear all errors?"}
                    >
                        {open => 
                            <button
                                type="button" className="btn btn-link text-primary p-1" style={{width: 130}}
                                data-mdb-ripple-color="dark"
                                onClick={() => open()}
                            >
                                Clear errors
                            </button>}
                    </ConfirmAction>
                    <MDBListGroup>
                        {errors.map(e =>
                            <MDBListGroupItem key={e.id} className="d-flex align-items-center">
                                <span className="text-muted fst-italic" style={{whiteSpace: 'nowrap', fontSize: 14}}>{new Date(e.ts).toLocaleString()}&nbsp;</span>
                                <span className="flex-fill ms-3 overflow-auto" style={{textWrap: 'wrap', wordWrap: 'break-word', flexWrap: 'wrap', overflowWrap: 'anywhere'}}>{e.message}</span>
                                <MDBBadge pill light>
                                    {e.type?.toLocaleUpperCase()}
                                </MDBBadge>
                            </MDBListGroupItem>
                        )}
                    </MDBListGroup>
                </div>
                
            }
        </MDBCard>
    )
}